import React from 'react';
import Item from './Item';
import s from './List.css';

// import Transition from 'react-motion-ui-pack';
import { TransitionMotion, spring, presets } from 'react-motion';
import ReactMotionFlip from 'react-motion-flip';

class List extends React.Component {


  // actual animation-related logic
  getDefaultStyles() {
    return this.props.items.map(item => ({
      key: item.id,
      data: item,
      style: { translateY: 100, opacity: 0,
    } }));
  }

  getStyles() {
    const { items } = this.props;
    return items.map((item) => {
      return {
//        ...item,
        key: item.id,
        data: item,
        style: {
          translateY: spring(100, presets.wobbly),
          opacity: spring(0, presets.wobbly),
        },
      };
    });
  }

  willEnter() {
    return {
      translateY: spring(0),
      opacity: spring(1),
    };
  }

  willLeave() {
    return {
      translateY: 0,
      opacity: 0,
    };
  }


  render() {
    const list = (
      <div className={s.list}>
        <ReactMotionFlip
          style={styles.list}
          childStyle={styles.item}
        >
      {
        this.props.items.map(item => {
          return (
            <Item
              key={item.id}
              item={item}
              selectItem={this.props.selectItem}
              selected={(this.props.selected === item.id)}
            />);
        })
      }
        </ReactMotionFlip>
      </div>
    );


    return (
      <div className={s.wrapper}>

{/*
        <pre>{this.props.items.length} products</pre>
        <hr />
*/}
        {list}
{/*
        <TransitionMotion
          defaultStyles={this.getDefaultStyles()}
          styles={this.getStyles()}
          willLeave={this.willLeave}
          willEnter={this.willEnter}
        >
        {interpolatedStyles =>
          <ul className={s.list}>
            {interpolatedStyles.map(({ key, style, data }) => {
              return (
                <Item
                  key={key}
                  style={style}
                  item={data}
                  selectItem={this.props.selectItem}
                  selected={(this.props.selected === key)}
                />);
            })
            }
          </ul>
        }
        </TransitionMotion>
*/}
      </div>
    );
  }
}

List.propTypes = {
  items: React.PropTypes.array.isRequired,
  selectItem: React.PropTypes.func.isRequired,
  selected: React.PropTypes.string.isRequired,
};

export default List;


const styles = {
  list: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  item: {
    flexBasis: '8em',
    flexGrow: 2,
    flexShrink: 1,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    padding: 10,
    backgroundColor: '#fff',
    borderRadius: 2,
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
    flexGrow: 1,
  },
};



/** WEBPACK FOOTER **
 ** ./components/Products/List.js
 **/